import React from "react";

// Styles
import useStyles from "./style";

// Material-UI
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";
// Components
import Gap from "../../../atoms/Gap";
import { AppBar } from "@material-ui/core";

function WithTitleSale({ title, onClick, back, onClickTitle, tipeOnClickTitle }) {
  const classes = useStyles();

  return (
    <AppBar position="static" className={classes.header}>
      {/* <Toolbar variant="dense"> */}
        {/* <div className={classes.header}> */}
        <div className={classes.wrapHeader}>
          <div>
            <IconButton size="small" onClick={onClick}>
              <ArrowBackIcon className={classes.icCart} />
            </IconButton>
          </div>
          <Gap width={20} />
          <div
            className={classes.wrapTitle}
            onClick={onClickTitle}
            style={{
              cursor: tipeOnClickTitle == "button" ? "pointer" : "default",
            }}
          >
            <Typography className={classes.title}>{title}</Typography>
          </div>
        </div>
        {/* </div> */}
      {/* </Toolbar> */}
    </AppBar>
  );
}

export default WithTitleSale;
